export default function PhilosophySection({ isVisible }) {
  return (
    <section
      id="philosophy"
      className={`py-24 lg:py-32 bg-[#EAE3D9] philosophy-bg transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="philosophy-section"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-12 heading-decorated-center">
          Philosophy
        </h2>

        {/* Main Manifesto */}
        <div className="space-y-8 mb-16">
          <p className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl lg:text-4xl text-[#1A1A1A] leading-relaxed">
            Bring who you are to the table.
          </p>
          <p className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl lg:text-4xl text-[#8B5A2B] leading-relaxed">
            Use your authentic self to your advantage.
          </p>
          <p className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl lg:text-4xl text-[#1A1A1A] leading-relaxed">
            Feel more at home at work.
          </p>
        </div>

        {/* Decorative divider */}
        <div className="divider-gold max-w-xs mx-auto mb-16"></div>

        {/* Supporting text */}
        <div className="max-w-2xl mx-auto">
          <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] mb-6">
            People do their best work when they feel:
          </p>
          <div className="flex flex-wrap justify-center gap-4 lg:gap-8">
            <span className="font-['Cormorant_Garamond'] text-xl lg:text-2xl text-[#1A1A1A] italic">
              Seen
            </span>
            <span className="text-[#C5A059]">•</span>
            <span className="font-['Cormorant_Garamond'] text-xl lg:text-2xl text-[#1A1A1A] italic">
              Heard
            </span>
            <span className="text-[#C5A059]">•</span>
            <span className="font-['Cormorant_Garamond'] text-xl lg:text-2xl text-[#1A1A1A] italic">
              Safe enough to be themselves
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
